module.exports = __webpack_public_path__ + "media/newstyle/images/logo-cda-mobile-178226e6e2d7742310e532e9d8fb6870.svg";